import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromTemplates from './templates.reducer';
import { TemplatesEffects } from './templates.effects';
import { TemplatesFacade } from './templates.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromTemplates.TEMPLATES_FEATURE_KEY,
      fromTemplates.reducer
    ),
    EffectsModule.forFeature([TemplatesEffects]),
  ],
  providers: [TemplatesFacade],
})
export class TemplatesStateModule {}
